import { Children, cloneElement, isValidElement, type ReactNode } from "react";

function formatText(text: string): ReactNode {
  return text.split(/(oneworld)/gi).map((part, index) =>
    /^oneworld$/i.test(part) ? (
      <span key={`${part}-${index}`} aria-label={part}>
        <strong>{part.slice(0, 3)}</strong>
        {part.slice(3)}
      </span>
    ) : (
      part
    ),
  );
}

export function formatOneworld(content: ReactNode): ReactNode {
  return Children.map(content, (child) => {
    if (typeof child === "string") {
      return formatText(child);
    }

    if (!isValidElement<{ children?: ReactNode }>(child)) {
      return child;
    }

    return cloneElement(child, undefined, formatOneworld(child.props.children));
  });
}
